import LoginContent from "../components/auth/LoginContent";


const Login = () => {
    return (
        <div>
            <LoginContent />
        </div>
    )
}

export default Login;